<div
	class="map-sizing"
	leaflet
	[leafletOptions]="baseOptions"
	[class.transparent]="isDisabled"
	(leafletClick)="isDisabled ? null : addMarker($event.latlng)"
	[(leafletCenter)]="baseOptions.center"
	[(leafletZoom)]="baseOptions.zoom"
>
	<div *ngIf="marker" [leafletLayer]="marker"></div>
</div>
